document.addEventListener('DOMContentLoaded', function () {

    function initFilterLPSlider(container) {
        const track = container.querySelector('.js-filter-lp-track');
        const dotsContainer = container.querySelector('.js-filter-lp-dots');
        let noImgMsg = container.querySelector('.js-filter-lp-no-img');
        const allSlides = Array.from(track.querySelectorAll('.filter-lp-list-slide:not(.clone)'));

        if (!track) return;

        let currentIndex = 0;
        let visibleSlides = [];
        let autoSlideInterval;
        let isTransitioning = false;
        let transitionTimeout;

        track.style.cursor = 'grab';
        track.style.touchAction = 'pan-y';
        track.style.userSelect = 'none';

        function getSliderConfig() {
            const width = window.innerWidth;
            if (width <= 600) {
                return { itemsPerView: 1, slideWidth: 70, centerMode: true };
            } else if (width <= 900) {
                return { itemsPerView: 2, slideWidth: 50, centerMode: false };
            } else if (width <= 1024) {
                return { itemsPerView: 3, slideWidth: 33.333, centerMode: false };
            } else {
                return { itemsPerView: 1, slideWidth: 100, centerMode: false };
            }
        }

        const MAX_IMAGES = parseInt(track.dataset.maxImages) || 4;
        function updateNoImgMessage(shouldShow) {
            /*
              The empty-size fallback is built here instead of shipping in the
              section markup, so its copy never sits in the server-rendered
              HTML — crawlers and AI scrape audits were reading the hidden
              placeholder div as if it were visible page content.
            */
            if (shouldShow && !noImgMsg) {
                noImgMsg = document.createElement('div');
                noImgMsg.className = 'filter-lp-no-img js-filter-lp-no-img';

                const messageLines = [
                    'No photos for this size yet.',
                    'Try another size to see more.'
                ];

                messageLines.forEach(line => {
                    const paragraph = document.createElement('p');
                    paragraph.textContent = line;
                    noImgMsg.appendChild(paragraph);
                });

                track.appendChild(noImgMsg);
            }

            if (noImgMsg) {
                noImgMsg.style.display = shouldShow ? 'block' : 'none';
            }
        }

        function filterSlides(targetSize) {
            isTransitioning = false;
            track.querySelectorAll('.filter-lp-list-slide.clone').forEach(el => el.remove());

            visibleSlides = [];
            allSlides.forEach(slide => {
                const slideSize = slide.getAttribute('data-size');
                const shouldBeVisible = (
                    targetSize !== 'NONE' &&
                    (targetSize === 'ALL' || slideSize === targetSize)
                );

                if (shouldBeVisible && visibleSlides.length < MAX_IMAGES) {
                    slide.classList.remove('hide-slide');
                    visibleSlides.push(slide);
                } else {
                    slide.classList.add('hide-slide');
                }
            });

            updateNoImgMessage(visibleSlides.length === 0);

            if (visibleSlides.length > 1) {
                const clonesBefore = visibleSlides.map(slide => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('clone');
                    clone.setAttribute('aria-hidden', 'true');
                    return clone;
                });
                const clonesAfter = visibleSlides.map(slide => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('clone');
                    clone.setAttribute('aria-hidden', 'true');
                    return clone;
                });

                clonesBefore.reverse().forEach(clone => track.prepend(clone));
                clonesAfter.forEach(clone => track.appendChild(clone));
                
                currentIndex = visibleSlides.length;
            } else {
                currentIndex = 0;
            }

            track.style.transition = 'none';
            updateSliderPosition();
            track.offsetHeight;
            track.style.transition = '';

            buildDots();
            startAutoSlide();
        }

        function updateSliderPosition() {
            if (visibleSlides.length === 0) return;
            const config = getSliderConfig();
            let offset = 0;
            if (config.centerMode) {
                offset = (100 - config.slideWidth) / 2;
            }
            const moveAmount = -(currentIndex * config.slideWidth) + offset;
            track.style.transform = `translateX(${moveAmount}%)`;
            updateDots();
        }

        function checkInfiniteLoop() {
            clearTimeout(transitionTimeout);
            if (visibleSlides.length <= 1) {
                isTransitioning = false;
                return;
            }

            const len = visibleSlides.length;
            if (currentIndex < len) {
                currentIndex += len;
                track.style.transition = 'none';
                updateSliderPosition();
                track.offsetHeight;
                track.style.transition = '';
            } else if (currentIndex >= len * 2) {
                currentIndex -= len;
                track.style.transition = 'none';
                updateSliderPosition();
                track.offsetHeight;
                track.style.transition = '';
            }
            isTransitioning = false;
        }

        track.addEventListener('transitionend', checkInfiniteLoop);

        function goNext() {
            if (isTransitioning) return;
            if (visibleSlides.length <= 1) return;
            isTransitioning = true;
            currentIndex++;
            updateSliderPosition();
            transitionTimeout = setTimeout(checkInfiniteLoop, 600); // Safety fallback
        }

        function goPrev() {
            if (isTransitioning) return;
            if (visibleSlides.length <= 1) return;
            isTransitioning = true;
            currentIndex--;
            updateSliderPosition();
            transitionTimeout = setTimeout(checkInfiniteLoop, 600); // Safety fallback
        }

        function goTo(index) {
            if (isTransitioning) return;
            if (visibleSlides.length <= 1) return;
            const targetIndex = visibleSlides.length + index;
            if (targetIndex === currentIndex) return;
            isTransitioning = true;
            currentIndex = targetIndex;
            updateSliderPosition();
            transitionTimeout = setTimeout(checkInfiniteLoop, 600); // Safety fallback
        }

        function buildDots() {
            if (!dotsContainer) return;
            dotsContainer.innerHTML = '';
            if (visibleSlides.length <= 1) return;
            const dotCount = visibleSlides.length;
            for (let i = 0; i < dotCount; i++) {
                const btn = document.createElement('button');
                btn.className = 'filter-lp-dot' + (i === 0 ? ' is-active' : '');
                btn.setAttribute('aria-label', 'Go to segment ' + (i + 1));
                btn.dataset.index = i;
                btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><circle cx="4" cy="4" r="4" transform="matrix(1 0 0 -1 0 8)"/></svg>`;
                btn.addEventListener('click', function () {
                    goTo(parseInt(this.dataset.index));
                    startAutoSlide();
                });
                dotsContainer.appendChild(btn);
            }
        }

        function updateDots() {
            if (!dotsContainer) return;
            const dots = dotsContainer.querySelectorAll('.filter-lp-dot');
            if (dots.length === 0) return;
            let dotIndex = currentIndex % visibleSlides.length;
            if (dotIndex < 0) dotIndex += visibleSlides.length;
            dots.forEach((dot, i) => {
                dot.classList.toggle('is-active', i === dotIndex);
            });
        }

        function startAutoSlide() {
            clearInterval(autoSlideInterval);
            if (visibleSlides.length <= 1) return;
            autoSlideInterval = setInterval(() => {
                goNext();
            }, 3000);
        }

        window.addEventListener('resize', function () {
            track.style.transition = 'none';
            buildDots();
            updateSliderPosition();
            track.offsetHeight;
            track.style.transition = '';
        });

        let startX = 0;
        let endX = 0;
        let isDragging = false;

        track.addEventListener('touchstart', (e) => {
            startX = e.changedTouches[0].screenX;
            clearInterval(autoSlideInterval);
        }, { passive: true });

        track.addEventListener('touchend', (e) => {
            endX = e.changedTouches[0].screenX;
            handleSwipe();
            startAutoSlide();
        }, { passive: true });

        track.addEventListener('mousedown', (e) => {
            if (isTransitioning) return;
            isDragging = true;
            startX = e.screenX;
            track.style.cursor = 'grabbing';
            clearInterval(autoSlideInterval);
            e.preventDefault();
        });

        track.addEventListener('mouseup', (e) => {
            if (!isDragging) return;
            isDragging = false;
            endX = e.screenX;
            track.style.cursor = 'grab';
            handleSwipe();
            startAutoSlide();
        });

        track.addEventListener('mouseleave', () => {
            if (isDragging) {
                isDragging = false;
                track.style.cursor = 'grab';
            }
            startAutoSlide();
        });

        track.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));

        function handleSwipe() {
            const threshold = 50;
            if (endX < startX - threshold) goNext();
            if (endX > startX + threshold) goPrev();
        }

        filterSlides('ALL');
        startAutoSlide();
    }

    const sliderSections = document.querySelectorAll('.hdt-filter-lp-section');

    sliderSections.forEach(section => {
        /*
          More than one LP section loads this engine (IL-LP Gallery Upload and
          IL-LP Image Carousel), so on a page carrying both it executes twice.
          Initialising the same container twice duplicates the clone set and
          leaves two autoplay timers fighting over currentIndex, which freezes
          the slider — so each container is claimed exactly once.
        */
        if (section.dataset.filterLpInit === 'true') return;
        section.dataset.filterLpInit = 'true';

        initFilterLPSlider(section);
    });
});
